export default __webpack_public_path__ + "static/merkl-2ccf108c9fffa4598e9509c823df08d8.svg";